<script context="module">
    import { writable } from "svelte/store";

    export const caption = writable("");
</script>

<script>
    import TopAppBar, { Row, Section, Title } from "@smui/top-app-bar";
</script>

<TopAppBar variant="fixed" color="primary">
    <Row>
        <Section>
            <Title>{$caption}</Title>
        </Section>
    </Row>
</TopAppBar>
